<template>
	<div class="my-2">
		<label v-if="name" class="mb-2 small text-dark fs-6" :for="name"
			>{{ name }}
			<span v-if="required" class="text-danger">*</span>
		</label>
		<MultiSelect
			:options="options"
			:searchable="true"
			v-model="data.value"
			:mode="mode"
			@search-change="dataChange"
			:hideSelected="false"
			:closeOnSelect="closeOnSelect"
		/>
	</div>
</template>

<script>
	import { reactive, watch, watchEffect, onMounted } from "vue";
	import validator from "@/config/validator";
	import MultiSelect from "@vueform/multiselect";

	export default {
		name: "BaseMultiSelect",
		components: {
			MultiSelect,
		},
		props: {
			options: {
				type: [Array, Object],
				required: true,
			},
			name: {
				type: String,
			},
			rules: {
				type: String,
			},
			mode: {
				type: String,
				default: "single",
			},
			componentId: {
				type: [Number, Boolean],
				default: false,
			},
			defaultData: {
				type: [Number, String, Object, Array],
				default: "",
			},
			closeOnSelect: {
				type: Boolean,
				default: true,
			},
			required: {
				type: Boolean,
				default: false,
			},
		},
		emits: [`update:value`, `change:value`, `valError`, `valSuccess`],

		setup: (props, { emit }) => {
			const data = reactive({
				value: null,
				options: [],
			});

			data.options = props.options;

			const setData = () => {
				data.value = props.defaultData;
			};

			const dataChange = async (data) => {
				if (data?.length < 3) return;
				let value = {};
				if (props.componentId) value.componentId = props.componentId;
				value.name = data;
				emit(`change:value`, value);
				return;
			};

			if (props.defaultData) {
				setData(props.defaultData);
			}



			watch(
				() => data.value,
				(newValue, prevValue) => {
					if (props.componentId)
						newValue = { id: newValue, componentId: props.componentId };
					emit(`update:value`, newValue);
					validate(newValue);
					
					return;
				},
			);
			watch(
				() => props.defaultData,
				(newVal, preVal) => {
					if (props.defaultData instanceof  Array && data.value instanceof Array && (props.defaultData.length > data.value.length) ){
						data.value = [...props.defaultData];
					}
				}
			)

			const validationState = reactive({
				error: false,
				field: null,
				message: null,
			});

			const setState = function (data = false) {
				validationState.error = data.val || false;
				validationState.message = data.message || null;
				validationState.field = data.name || null;
			};

			const validate = async function (value) {
				if (!props.rules) {
					emit("valSuccess", { error: false, field: props.name });
					return;
				}
				try {
					let result = await validator.validateForm(
						props.name,
						props.rules,
						value,
					);
					if (!result.success) {
						setState({
							val: true,
							message: result?.message,
							name: result?.field_name,
						});
						emit("valError", { error: true, field: result?.field_name });
						return;
					}
					setState();
					emit("valSuccess", {
						error: false,
						field: result?.field_name,
					});
					return;
				} catch (err) {
					console.log("error in validate fn ::");
					console.log(err);
				}
			};
			return {
				data,
				dataChange,
				validate,
			};
		},
	};
</script>

<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
	.multiselect {
		font-size: var(--ms-font-size, 0.9rem) !important
		;
		min-height: calc(
			var(--ms-border-width, 1px) * 2 + var(--ms-font-size, 0.8rem) *
				var(--ms-line-height, 1) + var(--ms-py, 0.5rem) * 2
		) !important;
		height: 37px;
	}
	
	label.mb-2.small.text-dark.fs-6 {
		color: #00A0E3 !important;
	}
</style>
